import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import PropTypes from "prop-types";

const StyledButton = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-weight: bold;
  align-self: flex-start;
  padding: 8px 30px;
  text-transform: uppercase;
  color: ${({ color }) => `#${color}`};
  border: 2px solid ${({ bordercolor }) => `#${bordercolor}`};
  font-size: 14px;
  margin-right: auto;

  &:hover {
    background-color: ${({ hoverbackcolor }) => `#${hoverbackcolor}`};
    color: ${({ hovercolor }) => `#${hovercolor}`};
  }
`;

const Container = styled.div`
  margin-top: ${({ marginTopPx }) => `${marginTopPx}px`};
  width: ${({ width }) => (width ? `${width}px` : `auto`)};
  display: flex;
`;

const Button = ({
  uri,
  color,
  bordercolor,
  hovercolor,
  hoverbackcolor,
  text,
  marginTopPx,
  width,
  target,
  onClick,
  ...rest
}) => (
  <Container marginTopPx={marginTopPx} width={width} {...rest}>
    <StyledButton
      to={uri}
      color={color}
      target={target}
      bordercolor={bordercolor}
      hovercolor={hovercolor}
      hoverbackcolor={hoverbackcolor}
      onClick={onClick}
    >
      {" "}
      {text}{" "}
    </StyledButton>
  </Container>
);

Button.defaultProps = {
  uri: "",
  color: PropTypes.string,
  hovercolor: "fff",
  hoverbackcolor: "ff4400",
  bordercolor: "ff4400",
  text: "",
  marginTopPx: 0,
  target: "_self",
  onClick: () => {},
};

Button.propTypes = {
  uri: PropTypes.string,
  color: PropTypes.string,
  hovercolor: PropTypes.string,
  hoverbackcolor: PropTypes.string,
  bordercolor: PropTypes.string,
  text: PropTypes.string,
  marginTopPx: PropTypes.number,
  width: PropTypes.number,
  target: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;
